<!--
   @createdBy: 黄健
   @date: 2020-01-08
   @description：地址级联组件
-->
<template>
	<el-cascader class="lnk-cascader-address"
				 ref="cascader"
				 :inner-path="innerPath"
				 :outer-path="outerPath"
				 :disabled="disabled"
				 :class="classname"
				 :props="props"
				 :options="addrStore.addrOptions"
				 :change-on-select="elVersion === '2.8.2'"
				 @change="handleChange"
				 @expand-change="expandChange"
				 :placeholder="$t('LnkAddressCascader.placeholder')"
				 v-model="myAddr"
				 size="mini"></el-cascader>
</template>

<script>
	import {getStore} from "./addr-store";

	export default {
        name: "lnk-address-cascader",
		model:{event:'change'},
		props:{
        	/*v-model绑定值*/
        	value: [Array,Object],
			/*属性映射图*/
			propMapping: {
				type: Array,
				default(){
					return [0, 1, 2];
				}
			},
			/*元素类名*/
			classname: String,
			/*是否禁用*/
			disabled: Boolean,
			/*省区*/
			province: String,
			/*市区*/
			city: String,
			/*县区*/
			district: String
		},
		data(){
        	const addrStore = getStore(this);
        	return{
        		myAddr:this.getOuterAddrs(),//当前值
				addrStore //缓存器
			}
		},
		computed:{
        	/*当前省市区的路径*/
			innerPath(){
				return this.myAddr.join('/');
			},
			/*外部变量省市区的路径*/
			outerPath(){
				return this.getOuterAddrs().join('/');
			},
			/*element的版本*/
			elVersion(){
				return (window.ELEMENT || {}).version || '2.8.2';
			},
		},
		watch:{
			innerPath(path){
				this.addrStore.loadByPath(path);
			},
			outerPath(path){
				if(path !== this.myAddr.join('/')){
					this.myAddr = (path || '').split('/');
				}
			}
		},
		methods:{
        	/**
        	 * @method：getOuterAddrs
        	 * @createdBy:黄健
        	 * @date:2020/1/8
        	 * @params：
        	 * @description：获取外部省市区的值
        	 */
			getOuterAddrs(){
				const propMap = this.propMapping;
				const province = (this.value || {})[propMap[0]] || this.province;
				const city = (this.value || {})[propMap[1]] || this.city;
				const district = (this.value || {})[propMap[2]] || this.district;
				let addrs = [];
				if(province) {
					addrs.push(province);
					if(city){
						addrs.push(city);
						if(district){
							addrs.push(district);
						}
					}
				}
				return addrs;
			},
        	/**
        	 * @method：handleChange
        	 * @createdBy:黄健
        	 * @date:2020/1/8
        	 * @params：
        	 * @description：选中地址变化
        	 */
			handleChange(){
				let value = null;
				const myAddr = this.myAddr;
				const province = myAddr[0] || '';
				const city = myAddr[1] || '';
				const district = myAddr[2] || '';
				if(typeof this.value === 'object'){
					value = Array.isArray(this.value)?[]:{...this.value};
					const propMap = this.propMapping;
					value[propMap[0]] = province;
					value[propMap[1]] = city;
					value[propMap[2]] = district;
				}
				this.$emit('update:province',province);
				this.$emit('update:city',city);
				this.$emit('update:district',district);
				this.$emit('change', value || myAddr);
			},
			/**
			 * @method：expandChange
			 * @createdBy:黄健
			 * @date:2020/1/8
			 * @params：
			 * @description：展开节点变化时触发
			 */
			expandChange(addrs){
				const path = addrs.join('/');
				this.addrStore.loadByPath(path);
			}
		},
		mounted() {
			this.addrStore.loadByPath(this.outerPath);
		}
	}
</script>

<style scoped>

</style>
